import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useEffect, useId, useRef, useState } from 'react'

// Zeigt den Tooltip bei Hover und bei Tastaturfokus. Escape blendet einen
// sichtbaren Tooltip aus, ohne einen umgebenden Dialog zu schließen. Der
// unsichtbare Tooltip fängt keine Klicks ab.
const NativeTooltip = ({ className, text, delay, position, children }) => {
  const id = useId()
  const [visible, setVisible] = useState(false)
  const timeoutRef = useRef(null)

  const showTooltip = () => {
    clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => {
      setVisible(true)
    }, delay)
  }

  const hideTooltip = () => {
    clearTimeout(timeoutRef.current)
    setVisible(false)
  }

  const handleKeyDown = (event) => {
    if (event.key !== 'Escape' || !visible) return
    // HeadlessUI-Dialoge ignorieren Escape mit defaultPrevented
    event.preventDefault()
    hideTooltip()
  }

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [])

  return (
    <div
      className={className}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      onFocus={showTooltip}
      onBlur={hideTooltip}
      onKeyDown={handleKeyDown}
    >
      {children}
      <div
        id={id}
        role='tooltip'
        aria-hidden={!visible}
        className={clsx(
          'pointer-events-none absolute left-1/2 z-20 -translate-x-1/2 transform rounded bg-gray-900 px-3 py-1.5 transition-[opacity,visibility] duration-200 ease-in-out',
          'whitespace-nowrap text-center text-xs font-medium text-white',
          position === 'bottom' ? 'top-full mt-2' : 'bottom-full mb-2',
          visible ? 'visible opacity-100' : 'invisible opacity-0'
        )}
      >
        {text}
      </div>
    </div>
  )
}

NativeTooltip.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  delay: PropTypes.number,
  position: PropTypes.oneOf(['top', 'bottom']),
  children: PropTypes.node.isRequired
}

NativeTooltip.defaultProps = {
  className: 'relative flex cursor-pointer',
  delay: 1000,
  position: 'top'
}

export default NativeTooltip
